import { useCallback, useEffect, useState } from "react"
import { get } from "helpers/api_helper"
import { proposalMessage } from "./proposalMessages"

// One proposal with its history (Phase A6), read again on demand; a published one also carries its publication (Phase E1p). No id, no
// read. The answer shown is always the one read for the id asked.
export default function useProposalRead(id) {
  const [state, setState] = useState({})
  const [attempt, setAttempt] = useState(0)
  useEffect(() => {
    if (!id) return undefined
    let current = true
    get("/admin/tournament-proposals/" + id)
      .then(response => current && setState({ id, proposal: response?.data?.proposal, history: response?.data?.history || [] }))
      .catch(error => current && setState({ id, error: error?.response?.status === 404 ? proposalMessage("PROPOSAL_NOT_FOUND")
        : "The proposal could not be loaded." }))
    return () => { current = false }
  }, [id, attempt])
  const reload = useCallback(() => setAttempt(value => value + 1), [])
  return { ...(state.id === id ? state : {}), reload }
}
